var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rotation-form-drop-down"},[_c('rotation-drop-down',{attrs:{"disabled":_vm.disabled,"value":_vm.value},on:{"rotation-change":function($event){return _vm.onChange($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }